import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImage = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1024 910.222v-796.444c0-62.578-51.2-113.778-113.778-113.778h-796.444c-62.578 0-113.778 51.2-113.778 113.778v796.444c0 62.578 51.2 113.778 113.778 113.778h796.444c62.578 0 113.778-51.2 113.778-113.778zM335.644 624.64l119.467 143.929 176.356-226.987c11.378-14.791 34.133-14.791 45.511 0.569l199.68 266.24c14.222 18.773 0.569 45.511-22.756 45.511h-682.098c-23.893 0-36.978-27.307-22.187-46.080l141.653-182.044c10.809-14.791 32.427-15.36 44.373-1.138z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgImage);
export default ForwardRef;
